import { useMutation, useQueryClient } from 'react-query';
import { updateReferralActivityMedication } from '@/app/services/RMSService';
import errorHandler from '@/app/utils/errorHandler';

function useUpdateReferralActivityMedicationMutation() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ patientId, referralId, activityId, medicationId, data }) =>
            updateReferralActivityMedication(patientId, referralId, activityId, medicationId, data),
        {
            onSuccess: async (referralActivityMedication, variables) => {
                const queryPatientId = variables?.patientId;
                const queryReferralId = variables?.referralId;
                const queryActivityId = variables?.activityId;
                const queryMedicationId = variables?.medicationId;

                if (!queryPatientId || !queryReferralId || !queryActivityId || !queryMedicationId) {
                    return;
                }

                await queryClient.setQueryData(
                    [
                        'patient',
                        queryPatientId,
                        'referral',
                        queryReferralId,
                        'activity',
                        queryActivityId,
                        'medication',
                        queryMedicationId,
                    ],
                    referralActivityMedication
                );
            },
            onError: errorHandler,
        }
    );
}

export default useUpdateReferralActivityMedicationMutation;
